module.exports = __webpack_public_path__ + "static/media/train-reverse.24d557db.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/train-reverse.png
// module id = 324
// module chunks = 0